export const SCHEMA_NAME = "Transport";

export const FIELDS = {
  TRANSPORT_ID: "transportID",
  DATE_ADDED: "dateAdded",
  TIME_ADDED: "timeAdded",
  CREATOR_STAFF_ID: "creatorStaffID",
  JACKET_ID: "jacketID",
  BIO_ID: "bioID",
  INMATE_TRACKING_ID: "inmateTrackingID",
  FROM_LOCATION: "fromLocation",
  TO_LOCATION: "toLocation",
  TRANSPORT_STATUS: "transportStatus",
  SCHEDULED_DATE: "scheduledDate",
  SCHEDULED_TIME: "scheduledTime",
  START_DATE: "startDate",
  START_TIME: "startTime",
  START_MILEAGE: "startMileage",
  END_DATE: "endDate",
  END_TIME: "endTime",
  END_MILEAGE: "endMileage",
  TRANSPORT_OFFICER_STAFF_ID: "transportOfficerStaffID",
  COMMENTS: "comments",
  HOUSING_AGENCY: "housingAgency",
  IN_JAIL: "inJail",
  MOVE_REASON: "moveReason",
  BATCH_TRANSPORT_STATUS: "batchTransportStatus",
};
